import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config.js";
import DownloadButtons from "../DownloadButtons/DownloadButtons.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const LeaveReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [filters, setFilters] = useState({
    start_date: today,
    end_date: today,
    leave_type: "ALL",
    leave_status: "2",
    action_type: "Fetch",
  });

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= FETCH LEAVE TYPES ================= */
  const fetchLeaveTypes = async () => {
    try {
      const res = await axios.get(API_BASE_URL + "/leave_types", {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      });

      setLeaveTypes(res.data?.data?.leave_type || []);
    } catch {
      toast.error("Failed to load leave types");
    }
  };

  useEffect(() => {
    fetchLeaveTypes();
  }, []);

  /* ================= FETCH REPORT ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        API_BASE_URL + "/leave_report",
        filters,
        { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
      );

      setRecords(res.data.records || []);
      toast.success("Report loaded successfully!", {
        position: "bottom-right",
        theme: "colored",
      });
    } catch {
      toast.error("Error fetching leave report");
    } finally {
      setLoading(false);
    }
  };

  /* ================= SEARCH ================= */
  const filteredRecords = records.filter((item) =>
    `${item.employee_id} ${item.employee_name} ${item.department} ${item.leave_type}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
    { name: "Employee ID", selector: r => r.employee_id, sortable: true },
    { name: "Employee Name", selector: r => r.employee_name, sortable: true },
    { name: "Department", selector: r => r.department, sortable: true },
    { name: "Applied On", selector: r => r.applied_on, sortable: true },
    { name: "From Date", selector: r => r.from_date, sortable: true },
    { name: "To Date", selector: r => r.to_date, sortable: true },
    { name: "No. of Days", selector: r => r.no_of_days, sortable: true, right: true },
    { name: "Leave Type", selector: r => r.leave_type, sortable: true },
    { name: "Incharge", selector: r => r.incharge_name },
    { name: "HOD", selector: r => r.hod_name },
    { name: "HR Approval", selector: r => r.hr_approval },
     { name: "Status", selector: r => r.status_label },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#7d858369",
        fontWeight: "bold",
      },
    },
  };

  return (
    <div className="container-fluid mt-4">
      <ToastContainer />
<div className="mb-3 d-flex flex-wrap gap-2">
          <a href="/leave-report" className="btn btn-info btn-sm">
            Leave Report
          </a>
          <a href="/no-leave" className="btn btn-outline-secondary btn-sm">
             Unavailed Leave
          </a>
        </div>
      {/* ================= FILTER CARD ================= */}
      <div className="card shadow-sm mb-4">
        <div className="card-header">Leave Report</div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3 align-items-end">

           <div className="col-md-2">
  <label>From Date</label>

  <DatePicker
    selected={filters.start_date ? new Date(filters.start_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        start_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select From Date"
    className="form-control"
    maxDate={filters.end_date ? new Date(filters.end_date) : null}
  />
</div>

<div className="col-md-2">
  <label>To Date</label>

  <DatePicker
    selected={filters.end_date ? new Date(filters.end_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString("en-CA")
        : "";

      setFilters((prev) => ({
        ...prev,
        end_date: value,
      }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select To Date"
    className="form-control"
    minDate={filters.start_date ? new Date(filters.start_date) : null}
  />
</div>


              <div className="col-md-3">
                <label>Leave Type</label>
                <Select
                  options={leaveTypes.map(l => ({ value: l.value, label: l.label }))}
                  isClearable
                  placeholder="All"
                  value={leaveTypes
                    .map(l => ({ value: l.value, label: l.label }))
                    .find(o => o.value === filters.leave_type) || null}
                  onChange={(opt) =>
                    handleInput({
                      target: { name: "leave_type", value: opt ? opt.value : "ALL" },
                    })
                  }
                />
              </div>

              <div className="col-md-2">
                <label>Status</label>
                <select className="form-control"
                  name="leave_status" value={filters.leave_status}
                  onChange={handleInput}>
                  <option value="1">Pending</option>
                    <option value="2">Approved</option>
                  <option value="3">Rejected</option>
                </select>
              </div>

              <div className="col-md-2">
                <button className="btn btn-primary w-100">Get</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="card">
        <div className="card-header text-danger">
          Employee Leave Report
        </div>
        <div className="card-body">

          <div className="d-flex justify-content-between mb-3">
            <DownloadButtons
              data={filteredRecords}
              filename="Leave_Report"
            />

            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search..."
              style={{ width: "220px" }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <DataTable
            columns={columns}
            data={filteredRecords}
            pagination
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            progressPending={loading}
            striped
            highlightOnHover
            dense
            customStyles={customStyles}
            noDataComponent={
              <div className="p-3 text-danger fw-bold">
                No records found
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default LeaveReport;
